import React, { useEffect, useState } from "react";
import {Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure, Input} from "@nextui-org/react";
import axios from "axios";
import { toast } from "react-toastify";
import { products_uri } from "../../../../utils/url";

export default function ProductPrice({product}) {
  const {isOpen, onOpen, onOpenChange} = useDisclosure();
  const [load, setLoad] = useState(false);
  const [price, setPrice] = useState('');
  const [prod, setProd] = useState([]);

  const Get = async () => {
    setLoad(true);
    try{
        const res = await axios.get(products_uri+'/price'+`?id=${product.id}`);
        setProd(res.data);
        setLoad(false);
    }catch(err){
        console.log(err);
        setLoad(false);
    }
  }

  const Sub = async () => {
    setLoad(true);
    try{
        const res = await axios.post(products_uri+'/price', {id: product.id, price: price});
        if(res.status === 200){
            Get();
            setPrice('');
            toast.success("Амжилттай");
            setLoad(false);
        }
        setLoad(false);
    }catch(err){
        console.log(err);
        setLoad(false);
    }
  }
  
  const On = () => {
    Get();
    onOpen();
  }

  const callback = () => {
    Get();
  }

//   useEffect(() => {
//     Get();
//   }, [product])
  

  return (
    <>
      <Button size="sm" className="" onPress={On}>Үнэ нэмэх</Button>
      <Modal isOpen={isOpen} onOpenChange={onOpenChange} scrollBehavior="inside">
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1">{product.name} мэдээлэл</ModalHeader>
              <ModalBody>
                <div className="mt-0 font-Roboto">
                    <div>
                        <h1 className="text-xs font-bold">Үнэ оруулах *</h1>
                        <Input onChange={(e)=> setPrice(e.target.value)} value={price} size="sm" className="mt-2" placeholder="Үнэ оруулах"/>
                        {
                            load?
                            <Button className="w-full mt-4 bg-indigo-600 text-white">Уншиж байна ...</Button>
                            :
                            <Button className="w-full mt-4 bg-indigo-600 text-white" onPress={Sub}>Нэмэх</Button>
                        }
                    </div>
                    <div className="mt-4">
                        {
                            prod.map((it, index) => {
                                return(
                                    <div key={index}>
                                        <div className="p-2 rounded-md ring-1 mt-2 font-bold text-xs flex justify-between items-center">
                                            {it.price}
                                            {/* <UpdateModal data={it} callback={callback}/> */}
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="danger" variant="light" onPress={onClose}>
                  Close
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}
